export default __webpack_public_path__ + "static/media/jet-about2_converted.40f28885.jpg";